import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../environments/environment';
import { AssetDepreciationImportResult } from '../models/monthly-uploads/asset-depreciation-import';
import { MonthlyAssetDepreciation } from '../models/monthly-uploads/monthly-asset-depreciation';

export interface MonthlyAssetDepreciationSearchCommand {
  assetId: string | null;
  year: number;
  month: number;
}

@Injectable({ providedIn: 'root' })
export class AssetDepreciationImportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.assetApi + '/api/v1/monthly-asset-depreciation';

  public importMonthly(month: number, year: number, file: File): Observable<ApiResponse<AssetDepreciationImportResult>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    const params = new HttpParams().set('month', String(month)).set('year', String(year));

    return this.httpClient.post<ApiResponse<AssetDepreciationImportResult>>(`${this.baseUrl}/import-excel`, formData, {
      params,
    });
  }

  public search(command: MonthlyAssetDepreciationSearchCommand): Observable<ApiResponse<MonthlyAssetDepreciation[]>> {
    return this.httpClient.post<ApiResponse<MonthlyAssetDepreciation[]>>(`${this.baseUrl}/search`, command);
  }
}
